import React from "react";
import { Spinner } from "components/common";
import { TrafficGraphWithDaySelect } from "components/common/Graph";
import useGraphDays from "components/common/Graph/contexts/useGraphDays";
import useActiveLicenseInformation from "license/hooks/useActiveLicenseInformation";
import { isEnterpriseLicense, isDailyLicenseType } from "license/helper/activeLicense";
import { LICENSE_TYPE } from "license/constants";
import DrawDownLicenseVolumeGraph from "license/DrawDownLicenseVolumeGraph";
import ClusterTrafficGraph from "components/cluster/ClusterTrafficGraph";
import useClusterTraffic from "components/cluster/hooks/useClusterTraffic";
const TrafficGraph = () => {
  const { data: activeLicenseData, isLoading } = useActiveLicenseInformation();
  const { graphDays } = useGraphDays();
  const { traffic } = useClusterTraffic(graphDays);
  if (isLoading) return /* @__PURE__ */ React.createElement(Spinner, null);
  if (!isEnterpriseLicense(activeLicenseData)) {
    return /* @__PURE__ */ React.createElement(ClusterTrafficGraph, null);
  }
  if (activeLicenseData.license_type === LICENSE_TYPE.drawDown) {
    return /* @__PURE__ */ React.createElement(DrawDownLicenseVolumeGraph, null);
  }
  if (isDailyLicenseType(activeLicenseData.license_type)) {
    const {
      details: { traffic_limit: trafficLimit }
    } = activeLicenseData;
    const isRaw = activeLicenseData.license_type === LICENSE_TYPE.dailyUsageRaw;
    const graphTraffic = isRaw ? traffic == null ? void 0 : traffic.input_indexed : traffic == null ? void 0 : traffic.output;
    if (!graphTraffic) return null;
    return /* @__PURE__ */ React.createElement(
      TrafficGraphWithDaySelect,
      {
        trafficType: isRaw ? "input-indexed" : "output",
        traffic: graphTraffic,
        trafficLimit
      }
    );
  }
  return null;
};
export default TrafficGraph;
